import { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";

const CentralModal = ({
    isOpen,
    onClose,
    title,
    width = "max-w-3xl",
    className = "",
    children,
}) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0  z-50 flex justify-center items-start overflow-y-auto bg-black/60 backdrop-blur-sm p-4 sm:p-8">
            <div
                className="fixed inset-0 -z-10"
                onClick={onClose}
            />

            <div
                className={`relative bg-white rounded-xl shadow-2xl w-full ${width} ${className}
                           flex flex-col mt-4 mb-8 md:mt-10
                           animate-in fade-in zoom-in-95 duration-200`}
            >
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 shrink-0">
                    <h2 className="text-xl font-bold text-gray-800">
                        {title}
                    </h2>
                    <button
                        onClick={onClose}
                        className="p-2 -mr-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors"
                    >
                        <AiOutlineClose size={20} />
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto relative p-6">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default CentralModal;